/**
 * Client-approved user-facing strings (Stripe verification, platform fee labels).
 * Fee percentages are derived from `pricing-constants` so copy stays aligned with calculations.
 */

import { PRICING_CONSTANTS } from "@/lib/pricing-constants";

export const STRIPE_PAYMENT_VERIFICATION_HEADLINE =
  "Verify your payment details to start renting and receiving payouts securely.";

/** Stripe Identity verification succeeded — next step is Stripe Connect payment setup */
export const IDENTITY_VERIFIED_PAYMENT_SETUP_HEADLINE =
  "Almost there! Verify your payment details to unlock full access.";

/** Secondary line when Stripe exists but onboarding is incomplete */
export const STRIPE_PAYMENT_VERIFICATION_CONTINUE_SUBTEXT =
  "Complete onboarding to start receiving payouts.";

/** Helper under headline when user has not connected Stripe yet */
export const STRIPE_PAYMENT_VERIFICATION_CONNECT_HINT =
  "Connect Stripe to pay for rentals and receive payouts.";

function platformFeeLabel(rate: number): string {
  return `Platform fee (${Math.round(rate * 100)}%)`;
}

/** User-facing renter charge line (booking payment summaries, receipts where applicable) */
export const PLATFORM_FEE_RENTER_LABEL = platformFeeLabel(
  PRICING_CONSTANTS.RENTER_PLATFORM_FEE_PERCENTAGE
);

/** User-facing sharer deduction line (earnings breakdown) */
export const PLATFORM_FEE_SHARER_LABEL = platformFeeLabel(
  PRICING_CONSTANTS.SHARER_PLATFORM_FEE_PERCENTAGE
);

export const SOCIAL_INSTAGRAM_URL =
  "https://www.instagram.com/rent.it.forward?igsh=ZGZ0ZTIzcHl6eDJ4";

export const SOCIAL_FACEBOOK_URL =
  "https://www.facebook.com/share/1BnJ9vLMBD/?mibextid=wwXIfr";

/** Sharer listing flow: fee disclosure (aligned with booking payment summary wording). */
export const LISTING_PLATFORM_FEES_CALLOUT =
  `Renters pay a ${PLATFORM_FEE_RENTER_LABEL.toLowerCase()} on their booking total. ${PLATFORM_FEE_SHARER_LABEL} is deducted from your rental earnings when bookings complete.`;
